var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIkiCoPilot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.458 14.107c0 3.268-2.677 5.918-5.979 5.918S3.5 17.375 3.5 14.107c0-3.268 2.677-5.918 5.98-5.918 3.301 0 5.978 2.65 5.978 5.918zM9.48 18.625c2.521 0 4.565-2.023 4.565-4.518 0-2.495-2.044-4.518-4.565-4.518-2.52 0-4.564 2.023-4.564 4.518 0 2.495 2.043 4.518 4.564 4.518z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.972 9.1c-.167-3.12-2.776-5.6-5.97-5.6-3.195 0-5.804 2.48-5.971 5.6h1.417c.165-2.347 2.14-4.2 4.553-4.2s4.39 1.853 4.554 4.2h1.417z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.669 19.916c2.753-.53 4.831-2.93 4.831-5.809 0-3.268-2.677-5.918-5.979-5.918-1.9 0-3.594.878-4.69 2.247l.803 1.302A4.572 4.572 0 0118.52 9.59c2.521 0 4.565 2.023 4.565 4.518 0 2.38-1.86 4.33-4.22 4.505l.803 1.304z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.036 18.999c.216 3.074 2.803 5.5 5.964 5.5 3.302 0 5.98-2.648 5.98-5.917 0-3.057-2.343-5.572-5.348-5.885l.572.572-.812.812c2.338.197 4.173 2.137 4.173 4.501 0 2.495-2.044 4.518-4.565 4.518-2.373 0-4.323-1.792-4.544-4.083l-.7.701-.72-.719z"
  })));
}
export default SvgIkiCoPilot;